import { Add, Delete, Edit } from "@mui/icons-material";
import BlindsClosedIcon from "@mui/icons-material/BlindsClosed";
import { RemoveRedEye } from "@mui/icons-material";
import {
  Grid,
  IconButton,
  Skeleton,
  Stack,
  TableCell,
  Tooltip,
  Typography,
} from "@mui/material";
import EmptyContent from "components/EmptyContent";
import List from "components/UI/List";
import { useAlert } from "contexts/alertContext";
import { Feature } from "models/api";
import React, { useEffect, useState } from "react";
import { QueryClient, useMutation } from "react-query";
import Search from "components/Search/Search";
import { handleError } from "helpers/utils";
import useFetchSection from "hooks/useFetchSection";
import { InputTypes } from "constants/enums";
import { IFormField } from "models/app";
import EditModalReseller from "./partials/Edit";
import { AboutUSCells, editAboutUS, getAboutUs } from "framework/aboutus";
import { IAboutUS, IAboutUSInput } from "models/aboutus";

interface Props {
  feature: Feature;
}


const AboutUs: React.FC<Props> = ({ feature }) => {

  const [loading2, setLoading2] = useState<boolean>(false);
  const [openEdit, setOpenEdit] = useState<boolean>(false);
  const [SelectedPolicy, setSelectedPolicy] = useState<IAboutUS | null>(null);
  const [inputObj, setInputObj] = useState<IAboutUSInput>({} as IAboutUSInput);
  const { setAlert } = useAlert();


  const editUserMutation = useMutation({
    mutationFn: (data: { createInput: IAboutUSInput; resellerId: string }) => {
      return editAboutUS(data.createInput, data.resellerId);
    },
  });


  const {
    loading,
    data: AboutUS,
    error,
    revalidate,
  } = useFetchSection({
    fetchData: () => getAboutUs(),
    fetchPermission: async () => null,
    section: "About Us",
  });


  if (loading)
    return (
      <Stack spacing={2} p={2}>
        {Array.from({ length: 10 }).map((_, i) => (
          <Skeleton variant="rectangular" key={i} width="100%" height={30} />
        ))}
      </Stack>
    );

  const handleChange = (name: string, value: any) => {
    setInputObj((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const handleOpenEdit = (user: IAboutUS) => {
    setSelectedPolicy(user);
    setOpenEdit(true);
  };


  const handleClose = () => {
    setOpenEdit(false);
    setSelectedPolicy(null);
    setInputObj({} as IAboutUSInput)
  }

  const getBodyCells = (row: IAboutUS) => {
    let cells = Object.keys(row).map((key: string, i: number) => {
      if (key === "title")
        return {
          id: "title",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2">{row?.title}</Typography>
            </TableCell>
          ),
        };
      if (key === "content")
        return {
          id: "content",
          element: (
            <TableCell align={"left"} key={i}>
              <Typography variant="body2"><div dangerouslySetInnerHTML={{ __html: row?.content }} /></Typography>
            </TableCell>
          ),
        };


      if (key === "id")
        return {
          id: "actions",
          element: (
            <TableCell align={"left"} key={i}>
              <Stack
                direction={"row"}
                alignContent={"center"}
                spacing={1}
              >

                <Tooltip title={"Edit"}>
                  <IconButton
                    size={"small"}
                    color={"primary"}
                    onClick={() => handleOpenEdit(row)}
                  >
                    <Edit />
                  </IconButton>
                </Tooltip>
              </Stack>
            </TableCell>
          ),
        };
    });
    return cells;
  };


  const handleEdit = async () => {


    // if (
    //   !isValidNumber((inputObj.countryCode || SelectedPolicy!?.contactNumber) + (inputObj.contactNumber || SelectedPolicy!?.contactNumber)))


    //   return setAlert({
    //     open: true,
    //     message: "This Phone is not valid in this country",
    //     type: "error",
    //   });

    let createInput: IAboutUSInput = {
      ...SelectedPolicy,
      ...inputObj
    };
    try {
      setLoading2(true);
      await editUserMutation.mutateAsync({
        createInput,
        resellerId: SelectedPolicy!?.id?.toString()
      });



      setAlert({
        open: true,
        message: `About Us updated successfully`,
        type: "success",
      });
      revalidate();
      handleClose();
      setInputObj({} as IAboutUSInput);
      setLoading2(false);
    } catch (error: any) {
      setAlert({
        open: true,
        message: handleError(error) || "Something went wrong",
        type: "error",
      });
      setLoading2(false);
    }
  };


  let editBasicFields: IFormField[] = [
    {
      name: 'title',
      label: 'Title',
      type: InputTypes.TEXT,
      placeholder: 'Enter Title',
      defaultValue: SelectedPolicy?.title || '',
      internalLabel: true,
      required: true
    },
    {
      name: 'content',
      label: 'Content',
      type: InputTypes.EDITOR,
      placeholder: 'Enter Content',
      defaultValue: SelectedPolicy?.content || '',
      internalLabel: true,
      required: true
    }
  ];


  return (
    <>
      <Stack spacing={2} p={2}>
        <Grid
          container
          direction={"row"}
          justifyContent={"space-between"}
          alignItems="center"

        >
          <Stack
            direction={"row"}
            spacing={1}
            justifyContent={"space-between"}
            width={"100%"}
            sx={{ mb: 4 }}
          >
            <Typography
              variant="h3"
              color={"header.primary"}
            >
              {(feature.name)}
            </Typography>

            {/* <Tooltip title={"Add"}>
              <IconButton
                sx={{
                  color: "black",
                  height: 40,
                  width: 40,
                  transition: "0.5s",
                }}
                onClick={handleOpenAdd}
              >
                <Add />
              </IconButton>
            </Tooltip> */}

          </Stack>
        </Grid>

        {[AboutUS!].length > 0 && (
          <List
            headCells={AboutUSCells}
            data={[AboutUS!]}
            getBodyCells={getBodyCells}
            feature={feature}
            canEdit={false}
          />
        )}


      </Stack>

      {openEdit && (
        <EditModalReseller
          open={openEdit}
          loading={loading2}
          title={`Edit About Us`}
          basicFields={editBasicFields}
          onClose={handleClose}
          onSubmit={handleEdit}
          onChanges={handleChange}
        />
      )}

    </>
  );
};

export default AboutUs;
